import {Component, Input, OnInit} from '@angular/core';

import {TreeNode} from 'primeng/primeng';

import {ItemGroupService} from '../../../services/lookups/item-group.service';
import {ItemGroup} from '../../../models/lookups/item-group';
import {Query} from '../../../models/query/query';
import {Criterion} from '../../../models/query/criterion';
import {WebMethodResult} from '../../../models/web-method-result';

@Component({
  selector: 'bms-item-group-tree',
  templateUrl: './item-group-tree.component.html',
  styleUrls: ['./item-group-tree.component.scss']
})
export class ItemGroupTreeComponent implements OnInit {

  @Input()
  private selectionMode: string = 'single';

  private selectedGroups: TreeNode[];

  private groups: any[] = [];
  private error: WebMethodResult;

  constructor(private itemGroupService: ItemGroupService) {
  }

  ngOnInit() {
    this.listGroups(null);
  }

  nodeExpand(event: any) {
    if(event.node) {
      this.listGroups(event.node);
    }
  }

  nodeSelect(event) {
    if(event.node) {
      console.log(event.node);
    }
  }

  private listGroups(groupNode: TreeNode) {
    let qry: Query = new Query();
    if (groupNode == null)
      qry.and().and(Criterion.isNull(ItemGroup.TABLENAME, ItemGroup.PARENT_ID));
    else
      qry.and().and(Criterion.equal(ItemGroup.TABLENAME, ItemGroup.PARENT_ID, groupNode.data.id));
    qry.addOrderByField(ItemGroup.TABLENAME, ItemGroup.NAME, Query.ASC);

    this.itemGroupService.list(qry).subscribe(
      (groups: ItemGroup[]) => {
        groups.forEach((group: ItemGroup) => {
          let node = {
            label: group.name,
            data: group,
            expandedIcon: "fa-folder-open",
            collapsedIcon: "fa-folder",
            leaf: false
          };
          if (groupNode != null) {
            if (groupNode.children == null)
              groupNode.children = [];
            groupNode.children.push(node);
          }
          else
            this.groups.push(node);
        })
      },
      error => this.error = error);
  }
}
